// TenantLoadingPage.tsx - Página de Carga estilo ITOBOX
import React from 'react';
import { Package } from 'lucide-react';

const TenantLoadingPage: React.FC = () => {
  return (
    <div className="loading-page">
      <div className="loading-container">
        <div className="loading-icon">
          <Package size={48} />
        </div>
        <div className="spinner"></div>
        <p className="loading-text">Cargando información del sistema...</p>
      </div>

      <style>{`
                .loading-page {
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #FAFAFA;
                }

                .loading-container {
                    text-align: center;
                }

                .loading-icon {
                    width: 80px;
                    height: 80px;
                    background: #E3F2FD;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 24px;
                    color: #2196F3;
                }

                .spinner {
                    width: 48px;
                    height: 48px;
                    border: 4px solid #E0E0E0;
                    border-top-color: #2196F3;
                    border-radius: 50%;
                    animation: spin 0.8s linear infinite;
                    margin: 0 auto 16px;
                }

                .loading-text {
                    font-size: 14px;
                    color: #757575;
                    margin: 0;
                }

                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
    </div>
  );
};

export default TenantLoadingPage;
